import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Link,
  Button,
  Drawer,
  Typography,
  Avatar,
  Stack,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
// components
import Logo from "../../components/Logo";
import Scrollbar from "../../components/Scrollbar";
import NavSection from "../../components/NavSection";
import { MHidden } from "../../components/@material-extend";
//
import sidebarConfig from "./SidebarConfig";
import account from "../../_mocks_/account";
import { IsNotValue } from "src/constant/variable";
import { ClearIcon } from "@mui/x-date-pickers";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  const [filtereddata, setFilteredData] = useState({
    search: ""
  });
  const [filteredMenu, setFilteredMenu] = useState([]);

  const filterData = () => {
    const searchText = filtereddata.search.toLowerCase().trim();

    const filteredRoutes = sidebarConfig
      .map((route) => {
        const filteredChildren = route?.children
          ? route?.children.filter((child) => child.title.toLowerCase().includes(searchText))
          : [];

        const parentMatch = route.title.toLowerCase().includes(searchText);

        if (parentMatch || filteredChildren.length > 0 || searchText === "") {
          return route;
        }

        return null;
      })
      .filter(Boolean);

    setFilteredMenu(filteredRoutes);
  };

  useEffect(() => {
    filterData();
  }, [filtereddata, sidebarConfig]);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: "100%",
        "& .simplebar-content": {
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }}>
        <Box component={RouterLink} to="/" sx={{ display: "inline-flex" }}>
          <Logo />
        </Box>
      </Box>

      {/* <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar src={account.photoURL} alt="photoURL" />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
                {account.displayName}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {account.role}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box> */}
      <Stack sx={{ margin: 1, marginTop: 0 }}>
        {/* <TextField
          size="small"
          label="Search Menu"
          name="search-field"
          autoComplete="off"
          value={filtereddata?.search || ""}
          onChange={(e) => setFilteredData({ search: e.target.value })}
          InputProps={{
            autoComplete: "off",
            form: {
              autoComplete: "off"
            }
            // endAdornment: filtereddata?.search ? (
            //   <InputAdornment position="end">
            //     <IconButton size="small" edge="end" onClick={() => setFilteredData({ search: "" })}>
            //       <ClearIcon fontSize="small" />
            //     </IconButton>
            //   </InputAdornment>
            // ) : null
          }}
        /> */}
        <Box
          component="form"
          autoComplete="off"
          sx={{ width: "100%" }}
          onSubmit={(e) => e.preventDefault()}
        >
          <TextField
            fullWidth
            size="small"
            label="Search Menu"
            name="no-autofill-search"
            autoComplete="off"
            inputProps={{
              autoComplete: "off"
            }}
            value={filtereddata?.search || ""}
            onChange={(e) =>
              setFilteredData((prev) => ({
                ...prev,
                search: e.target.value
              }))
            }
            InputProps={{
              endAdornment: filtereddata?.search ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    edge="end"
                    onClick={() => setFilteredData({ search: "" })}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          />
        </Box>
      </Stack>

      <NavSection navConfig={filtereddata.search?.length > 0 ? filteredMenu : sidebarConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: "background.default"
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
